import { Injectable, Inject } from '@angular/core';
import { Client } from "./client";
import { Observable, Subject } from "rxjs/Rx";
import { AngularFireDatabase } from "angularfire2/database";
import { FirebaseApp } from "angularfire2";
import { Http } from "@angular/http";
import { firebaseConfig } from '../../../../environments/firebase.config';

@Injectable()
export class ClientsService {
  sdkdb: any;

  constructor(private af: AngularFireDatabase, @Inject(FirebaseApp) fb: FirebaseApp,
    private http: Http) {
    this.sdkdb = fb.database().ref();
  }

  findAllClients(): Observable<Client[]> {

    return this.af.list('clients')
      .map(Client.fromJsonList)

  }

  findClientByUrl(url: string): Observable<Client> {
    return this.af.list('clients', {
      query: {
        orderByChild: 'url',
        equalTo: url
      }
    })
      .map(results => Client.fromJson(results[0]));
  }

  loadNextClient(courseId: string, clientId: string): Observable<Client> {

    return this.af.list(`clientsPerCourse/${courseId}`, {
      query: {
        orderByKey: true,   // trier par $key
        startAt: clientId,  // à partir de la client clientId
        limitToFirst: 2     // on en retourne 2 le courant et le suivant
      }
    })
      // On garde le suivant (retounre la clé du suivant)
      .map(results => results[1].$key)
      // On retourne l'objet client dont la clé = clientId qui contient le résultat du map précédent
      .switchMap(clientId => this.af.object(`clients/${clientId}`))
      // On transforme l'objet retourné par le switchMap en object Json
      .map(Client.fromJson);
  }

  loadPreviousClient(courseId: string, clientId: string): Observable<Client> {
    return this.af.list(`clientsPerCourse/${courseId}`, {
      query: {
        orderByKey: true,
        endAt: clientId,
        limitToLast: 2
      }
    })
      .map(results => results[0].$key)
      .switchMap(clientId => this.af.object(`clients/${clientId}`))
      .map(Client.fromJson);
  }

  createNewClient(courseId: string, client: any): Observable<any> {

    const clientToSave = Object.assign({}, client, { courseId });

    const newClientKey = this.sdkdb.child('clients').push().key;

    let dataToSave = {};

    dataToSave["clients/" + newClientKey] = clientToSave;
    dataToSave[`clientsPerCourse/${courseId}/${newClientKey}`] = true;


    return this.firebaseUpdate(dataToSave);
  }

  firebaseUpdate(dataToSave) {
    const subject = new Subject();

    this.sdkdb.update(dataToSave)
      .then(
      val => {
        subject.next(val);
        subject.complete();

      },
      err => {
        subject.error(err);
        subject.complete();
      }
      );

    return subject.asObservable();
  }

  saveClient(clientId: string, client): Observable<any> {

    const clientToSave = Object.assign({}, client);
    delete (clientToSave.$key);

    let dataToSave = {};
    dataToSave[`clients/${clientId}`] = clientToSave;

    return this.firebaseUpdate(dataToSave);

  }


  // On fait le delete avec un appel REST pour faire changement lol
  deleteClient(clientId: string): Observable<any> {

    const url = firebaseConfig.databaseURL + '/clients/' + clientId + '.json';

    return this.http.delete(url);

  }


  requestClientDeletion(clientId: string, courseId: string) {
    this.sdkdb.child('queue/tasks').push({ clientId, courseId })
      .then(
      () => alert('client deletion requested !')
      );
  }

}



// WEBPACK FOOTER //
// C:/dev/Perso/urmeo/src/app/shared/model/aSupprimer/client.service.ts